import { getCookie, setCookie,  getUserInfo} from '/blocks/common/components/utility';

export class FreeResources {
    store = null;

    async init(store) {
        this.store = store;   
        this._initAppBuilderButton();
    }

    _initAppBuilderButton() {
        const enterAppBuilderButton = document.querySelector('.free-resources__button--enter-app-builder');
        if (enterAppBuilderButton !== null) {      
            enterAppBuilderButton.addEventListener('click', async (event) => {
                try {
                    setCookie('redirect', 'mode-choice');
                    if (getCookie('userguid') === '') {
                        this._showSignUpForm();
                        return;
                    }

                    await getUserInfo();
                    window.location.href = 'mode-choice';
                } catch (error) {
                    if (error instanceof SyntaxError) {
                        this._showSignUpForm();
                        return;
                    }
                }               
            });      
        }
    }

    _showSignUpForm() {
        this.store.dispatch('modalManagementSystem/addModalWindow', {
            content: 'SignUpForm'
        });
    }
}